import OperationalReportPage from './OperationalReportPage';
export default function TransferReconciliationReportPage(){return <OperationalReportPage kind="transfer-reconciliation"/>;}
